import Image from 'next/image';
import classNames from 'classnames';

import styles from './SolutionBriefing.module.scss';

const SolutionBriefing = ({ isLoggedIn }: { isLoggedIn: boolean }) => (
  <div className={classNames(styles['container'], { [styles['logged-in']]: isLoggedIn })}>
    <div className={styles['group-problems']}>
      <div className={styles['group-title']}>こんなお悩みありませんか？</div>
      <div className={styles['group-cards']}>
        <div className={classNames(styles['group-card-one'], styles['group-card-top'])}>
          <div className={styles['card-contents']}>
            <Image src="/static/images/icons/solution-down.svg" width={38} height={40} />
            <div className={styles['top-text']}>
              電話やチラシで営業したけど、
              <div className={styles['highlight-problems']}>コスパが悪い</div>
            </div>
          </div>
        </div>
        <div className={classNames(styles['group-card-one'], styles['group-card-top'])}>
          <div className={styles['card-contents']}>
            <Image src="/static/images/icons/solution-time.svg" width={40} height={40} />
            <div className={styles['top-text']}>
              新規獲得は必要だと思いつつも、なかなか
              <div className={styles['highlight-problems']}>営業に割く時間が取れない</div>
            </div>
          </div>
        </div>
        <div className={classNames(styles['group-card-one'], styles['group-card-top'])}>
          <div className={styles['card-contents']}>
            <Image src="/static/images/icons/solution-question.svg" width={40} height={40} />
            <div className={styles['top-text']}>
              web集客をやってみたいが、
              <div className={styles['highlight-problems']}>初めてでわからない</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className={styles['group-solution']}>
      <p className={styles['group-title-solution']}>ゼヒトモなら</p>
      <div className={styles['group-cards']}>
        <div className={classNames(styles['group-card-one'], styles['group-card-bottom'])}>
          <div className={styles['card-contents']}>
            <Image src="/static/images/icons/solution-growth.svg" width={39} height={40} />
            <div className={styles['highlight']}>
              <span className={classNames(styles['line-break'], styles['catch'])}>単月の売上</span>
              <span className={styles['big-number']}>280</span> 万円も！
              <div>AIの自動マッチで手間なく集客</div>
            </div>
          </div>
        </div>
        <div className={classNames(styles['group-card-one'], styles['group-card-bottom'])}>
          <div className={styles['card-contents']}>
            <Image src="/static/images/icons/solution-note.svg" width={31} height={40} />
            <div className={styles['highlight']}>
              <span className={classNames(styles['line-break'], styles['catch'])}>月間依頼数</span>
              <span className={styles['big-number']}>25,000</span> 件以上！<div>圧倒的な依頼数</div>
            </div>
          </div>
        </div>
        <div className={classNames(styles['group-card-one'], styles['group-card-bottom'])}>
          <div className={styles['card-contents']}>
            <Image src="/static/images/icons/solution-free.svg" width={40} height={40} />
            <div className={styles['highlight']}>
              <span className={styles['catch']}>登録料無料</span>
              <div>
                <span className={styles['line-break']}>充実のサポート体制で</span>初めての
                <br />
                web集客でも安心
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default SolutionBriefing;
